var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4504 33.7585C26.5459 33.7585 33.9193 26.3851 33.9193 17.2896C33.9193 8.19406 26.5459 0.820679 17.4504 0.820679C8.35483 0.820679 0.981445 8.19406 0.981445 17.2896C0.981445 26.3851 8.35483 33.7585 17.4504 33.7585Z",
    stroke: "#000",
    strokeWidth: 1.37241
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.981445 17.2896H33.9193",
    stroke: "#000",
    strokeWidth: 1.37241
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4508 0.820801C21.5702 5.33057 23.9112 11.1831 24.0384 17.2897C23.9112 23.3963 21.5702 29.2488 17.4508 33.7586C13.3315 29.2488 10.9905 23.3963 10.8633 17.2897C10.9905 11.1831 13.3315 5.33057 17.4508 0.820801V0.820801Z",
    stroke: "#000",
    strokeWidth: 1.37241,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.effa36afe65df08a07e44d875bc11212.svg";
export { ForwardRef as ReactComponent };